module.exports = __webpack_public_path__ + "img/papelaria.92340ed5.jpg";